import { IFactoid } from 'shared/types/houseInfo/factoid';

export const renderFactoids = (factoids: IFactoid[], Component: React.FC<IFactoid>) =>
  factoids.map(factoid => <Component {...factoid} key={factoid.title} />);
